import React from 'react'
import CashCheckInTypeItem from './CashCheckInTypeItem'
import CreditCardCheckInTypeItem from './CreditCardCheckInTypeItem'
import CardCheckInTypeItem from './CardCheckInTypeItem'
import OthersCheckInTypeItem from './OthersCheckInTypeItem'
import SearchField from './SearchField'

export default ({
  onCashSelect,
  onCreditCardSelect,
  onOthersSelect,
  cards = [],
  onCardSelect,
  filterText,
  onFilterTextChange,
}) => {
  const showPaymentOptions =
    !filterText || (filterText && filterText.trim().length === 0)

  return (
    <div className="flex flex-col h-full">
      <div className="mb-4">
        <SearchField
          value={filterText}
          onChange={onFilterTextChange}
          placeholder="Search cards..."
        />
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="grid grid-cols-3 gap-3">
          {showPaymentOptions && <CashCheckInTypeItem onClick={onCashSelect} />}
          {showPaymentOptions && (
            <CreditCardCheckInTypeItem onClick={onCreditCardSelect} />
          )}
          {showPaymentOptions && (
            <OthersCheckInTypeItem onClick={onOthersSelect} />
          )}
          {renderCardItems(cards, onCardSelect)}
        </div>
      </div>
    </div>
  )
}

const renderCardItems = (cards, onCardSelect) => {
  return cards.map((card) => (
    <CardCheckInTypeItem key={card.id} card={card} onClick={onCardSelect} />
  ))
}
